import React, {Component} from 'react';
import BackEnd from "../../../backend/BackEnd";
import ProductsSortModal from "./ProductsSortModal";
import ActionLink from "../../../controls/ActionLink";
import PdfViewerModal from "../../../modals/PdfViewerModal";

class Products extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isLoading: false,
        showSortsModal: false,
        showSpecificationModal: false,
        specificationId: null,
        items: []
    };
    getAll = new BackEnd.Production.GetAll({
        start: () => this.setState({isLoading: true}),
        end: () => this.setState({isLoading: false})
    });

    async componentDidMount() {
        let gridResult = await this.getAll.call();

        this.setState({items: gridResult});
    }

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-ios-list-outline"/> Справочники /
                                </span> Продукция
                            </h1>
                        </div>
                        <div className="col-xs-12 width-md-auto width-lg-auto width-xl-auto pull-md-right">
                            <button type="button" className="btn btn-primary btn-block"
                                    onClick={() => this.setState({showSortsModal: true})}>
                                Сорта
                            </button>
                        </div>
                    </div>
                </div>
                <div className="panel box">
                    <div className="box-row">
                        <div className="box-cell p-a-2">
                            <table className={`table table-striped ${this.state.isLoading ? 'form-loading' : ''}`}>
                                <thead>
                                <tr>
                                    <th>Артикул</th>
                                    <th>Полное название</th>
                                    <th>Размер</th>
                                    <th>ГОСТ</th>
                                    <th>Стандарт</th>
                                    <th>Состояние</th>
                                    <th>Влажность</th>
                                    <th>Сорт</th>
                                    <th>Настил</th>
                                    <th style={{width: '226px'}}>Спецификация и допуски</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.items.map(product =>
                                    <tr key={product.productId}>
                                        <td>{product.article}</td>
                                        <td>{product.fullName}</td>
                                        <td>{product.size}</td>
                                        <td>{product.gost}</td>
                                        <td>{product.standard}</td>
                                        <td>{product.condition}</td>
                                        <td>{product.humidity}</td>
                                        <td>{product.quality}</td>
                                        <td>{product.deckType}</td>
                                        <td className="text-center">
                                            {
                                                product.documentSpecificationId &&
                                                <ActionLink onClick={() => this.showSpecification(product.documentSpecificationId)}>
                                                    <i class="fa fa-file-text-o"/>
                                                </ActionLink>
                                            }
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <ProductsSortModal show={this.state.showSortsModal}
                                   onHide={() => this.setState({showSortsModal: false})}/>
                <PdfViewerModal documentId={this.state.specificationId}
                                show={this.state.showSpecificationModal}
                                onHide={() => this.setState({showSpecificationModal: false})}/>
            </div>
        );
    }

    showSpecification(specificationId) {
        this.setState({
            showSpecificationModal: true,
            specificationId
        });
    }
}

export default Products;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Products/Products.js